import * as requestFromServer from "./Curd";
import { NewAdscompanylistSlice, callTypes } from "./Slice";
import { NotificationManager } from "react-notifications";

const { actions } = NewAdscompanylistSlice;
export const fetchAdsListList = (queryParams, companyId) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));

  return requestFromServer
    .getAdsListList(queryParams, companyId)
    .then((response) => {
      console.log("response::fetchAdsListList ", response);
      const totalCount = response.data[0]?.param.totalRecords;
      const entities = response.data[0]?.param.data || []; // Use 'data' array to get the list of entities
      console.log("teeheherbjberjejferfr", response.data[0]?.param.data);
      dispatch(actions.contestListList({ totalCount, entities }));
      return response;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");

      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

// export const fetchAdsListList = (queryParams, companyId) => (dispatch) => {
//   dispatch(actions.emptyList());
//   dispatch(actions.startCall({ callType: callTypes.list }));

//   return requestFromServer
//     .getAdsListList(queryParams, companyId) // Pass the companyId to getAdsListList
//     .then((response) => {
//       console.log("response::fetchAdsListList ", response);
//       const totalCount = response.totalRecord;
//       const entities = response.entities;

//       console.log("totalCount, entities", totalCount, entities);

//       dispatch(actions.contestListList({ totalCount, entities }));
//     })
//     .catch((error) => {
//       const errMsg =
//         error.response && error.response.data && error.response.data.errors
//           ? error.response.data.errors[0].msg
//           : error.message;
//       NotificationManager.error(errMsg, "Error");
//       const totalCount = 0;
//       const entities = [];
//       dispatch(actions.contestListList({ totalCount, entities }));
//       dispatch(actions.catchError({ error, callType: callTypes.list }));
//     });
// };

export const fetchSingle = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.singleItemFetched({ coinStoresForEdit: undefined })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getItemById(id)
    .then((response) => {
      const item = response;

      console.log("fjdjsbfjdfbdfbjfb", response);
      dispatch(actions.singleItemFetched({ coinStoresForEdit: item }));
      return response;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchContestDetails = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getContestDetails(queryParams)
    .then((response) => {
      console.log("response::fetchContestDetails ", response);
      const contestData = response;
      console.log(
        "detailsssssssssssssss",
        contestData?.data[0]?.param?.gameType?.settings?.RPTime
      );
      dispatch(actions.contestDetails({ contestData }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchRules = (id) => (dispatch) => {
  if (!id) {
    return dispatch(actions.singleItemFetched({ ruless: undefined }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getRules(id)
    .then((response) => {
      const item = response.data;
      item.editGameTypes = response.gameTypes;
      console.log("rulesssssssssssssssssssssssssss", response);
      dispatch(actions.singleItemFetched({ ruless: item }));
      return response; // Return the response data
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      throw error; // Rethrow the error to be caught in the component
    });
};

// export const fetchScreenshot = id => dispatch => {
//   if (!id) {
//     return dispatch(actions.singleItemFetchedScreenshot({ screenshotimg: undefined }));
//   }
//   dispatch(actions.startCall({ callType: callTypes.action }));
//   return requestFromServer
//     .getScreenshot(id)
//     .then(response => {
//       const item = response.data;
//       item.screenshot = response.gameTypes;
//       console.log("SCRENNNNSHOTTTTTT", response?.data[0].param?.picture?.url)
//       dispatch(actions.singleItemFetchedScreenshot({ screenshotimg: item }));
//       return item; // Return the response data
//     })
//     .catch(error => {
//       const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
//       NotificationManager.error(errMsg, 'Error');
//       dispatch(actions.catchError({ error, callType: callTypes.action }));
//       throw error; // Rethrow the error to be caught in the component
//     });
// };

export const fetchScreenshot = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getScreenshot(queryParams)
    .then((response) => {
      console.log("response::fetchScreenshot ", response);
      const screenshot = response;
      console.log(
        "detailsssssssssssssss",
        response?.data[0]?.param?.picture?.url
      );
      dispatch(actions.singleItemFetchedScreenshot({ screenshot }));
      return response;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchCountriesList = (queryParams) => (dispatch) => {
  console.log("queryParams -> user -> com:", queryParams);
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCountriesList(queryParams)
    .then((response) => {
      console.log("response::All Country List", response);
      // const { totalCount, entities } = response.data;
      const countryList = response;
      console.log("countryList", countryList);
      dispatch(actions.CountryList({ countryList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCountriesDropdownList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCountriesDropdownList(queryParams)
    .then((response) => {
      console.log("response::All Country List", response);
      // const { totalCount, entities } = response.data;
      const countryDropdownList = response;
      console.log("countryDropdownList", countryDropdownList);
      dispatch(actions.CountryDropdownList({ countryDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchContestUsersList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getContestUsersList(queryParams)
    .then((response) => {
      console.log("response::fetchContestUsersList ", response);
      const contestUsers = response;
      console.log("usersssssssssss detailsss", contestUsers);
      dispatch(actions.contestUsersList({ contestUsers }));
      return response;
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchGameList = (queryParams) => (dispatch) => {
  // console.log('queryParams MOHIT:', queryParams)
  // dispatch(actions.emptyList());
  // console.log('queryParams MOHIT  ee: ', queryParams)
  return requestFromServer
    .getAllGamesList(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.gameList({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchGameTypeList = (queryParams) => (dispatch) => {
  console.log("queryParams MOHIT:", queryParams);
  // dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  console.log("queryParams MOHIT  ee: ", queryParams);
  return requestFromServer
    .getGameTypeList(queryParams)
    .then((response) => {
      console.log("response::getGameTypeList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.gameTypeList({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCompanyList = (queryParams) => (dispatch) => {
  // console.log("queryParams",queryParams)
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getCompany(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.company({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchcurrencyList = (queryParams) => (dispatch) => {
  // console.log("queryParams",queryParams)
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getcurrency(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.currency({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
